import type { MuscleGroup } from "./schema.ts";

/**
 * Every muscle a movement can train, in the order they are listed. Plain
 * data rather than read off the schema: the phone needs the list, and
 * reaching it through zod put zod in the app it downloads.
 */
export const MUSCLE_GROUPS = [
  "chest",
  "back",
  "traps",
  "shoulders",
  "biceps",
  "triceps",
  "forearms",
  "abs",
  "lower_back",
  "glutes",
  "quads",
  "hamstrings",
  "adductors",
  "calves",
] as const;

export function isMuscleGroup(value: string): value is MuscleGroup {
  return (MUSCLE_GROUPS as readonly string[]).includes(value);
}

/**
 * The secondary muscles as they are kept: each once, in the list's order,
 * never the target itself, and none while there is no target to be
 * secondary to.
 */
export function secondaryMusclesFor(primary: MuscleGroup | null, secondary: readonly MuscleGroup[]): MuscleGroup[] {
  if (primary === null) return [];
  return MUSCLE_GROUPS.filter((muscle) => muscle !== primary && secondary.includes(muscle));
}

/** The muscles as the app names them; the keys are what is stored. */
export const MUSCLE_LABEL: Record<MuscleGroup, string> = {
  chest: "Pectoraux",
  back: "Dos",
  traps: "Trapèzes",
  shoulders: "Épaules",
  biceps: "Biceps",
  triceps: "Triceps",
  forearms: "Avant-bras",
  abs: "Abdos",
  lower_back: "Lombaires",
  glutes: "Fessiers",
  quads: "Quadriceps",
  hamstrings: "Ischios",
  adductors: "Adducteurs",
  calves: "Mollets",
};

/**
 * The usual range of hard sets a week for a muscle to grow: the mark the
 * Muscles view reads each bar against ("6 sets of chest, is that little?").
 * The same for every muscle until the coach gives his own.
 */
export const WEEKLY_SETS = { low: 10, high: 20 } as const;
